<template>
  <div class="phone-validate">
    <div>
      <step-header :step="step"></step-header>
    </div>
    <div class="form-container">
      <div class="title-result">完成</div>
      <div class="result-info" v-if="$route.meta.verifyResult">
        <div class="line1">激活成功！</div>
        <div class="line2">你已成功激活账号，现在可以接入应用啦！</div>
      </div>
      <div class="result-info" v-else>
        <div class="line1">验证失败！</div>
        <div class="line2">验证链接已过期，请登录后重发验证邮件！</div>
      </div>
      <div class="success-btn">
        <button class="c-btn-add btn-result first" @click="jumpToAppmanage" v-if="$route.meta.verifyResult">
          <span class="text">立即接入</span>
        </button>
        <button class="e2-btn btn-result" @click="jumpToHome" >
          <span class="text">返回首页</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import RouteKey from '@/common/RouteKey';
import StepHeader from '../common/StepHeader';
export default {
  name: 'mail',
  components: {
    StepHeader
  },
  data() {
    return {
      step: 4
    };
  },
  methods: {
    jumpToAppmanage() {
      this.$router.transfer(RouteKey.OPEN_APP_DISPLAY);
    },
    jumpToHome() {
      this.$router.transfer(RouteKey.OPEN_HOME);
    }
  }
};
</script>

<style lang="less">
.phone-validate{
  .form-container{
    background: #ffffff;
    box-shadow: 0px 1px 25px 0px rgba(0, 0, 0, 0.13);
    .title-result{
      height: 118px;
      line-height: 118px;
      width: 200px;
      margin: 0 auto;
      color: #666666;
      font-size: 24px;
      text-align: center;
      background-image: url(./img/title_element_left.png),  url(./img/title_element_right.png);
      background-repeat: no-repeat;
      background-position: 0px center, right center;
    }
    .result-info{
      margin-left: 240px;
      font-size: 18px;
      color: #7E858D;
      padding-bottom: 130px;
      .line1{
        font-size: 25px;
        line-height: 36px;
        margin-bottom: 20px;
      }
      .line2{
        line-height: 30px;
      }
    }
    .success-btn{
      text-align: center;
      margin-top: 10px;
      padding-bottom: 60px;
    }
    .btn-result{
      vertical-align: top;
      width: 230px;
      &.first{
        margin-right: 27px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/validate/panels/ResultValidate.vue